<template>
  <div class="reserve">
    <div class="reserve-title">设置顾客抽的签</div>
    <div class="com-content" v-for="(item,index) in drawLotsData.drawLots" :key="index">
      <div class="title">
        <span>{{index + 1}}</span>
        <div>
          <span class="replace" @click="edit(item,index)" v-if="from !='manager'">
            编辑
          </span>
          <span class="replace" @click="edit(item,index)" v-else>
            {{item.status == 0 ? '下架并编辑' : '编辑并上架'}}
          </span>
          <span class="replace" v-if="from !='manager'" @click="handleDel(item,index)">删除</span>
        </div>
      </div>
      
      <van-field v-if="item.type != 'definition'" v-model="item.typeName" label="签标题" input-align="right" readonly />
      <van-field v-else v-model="item.definitionTitle" label="签标题" input-align="right" readonly />
      <van-field v-model="item.drawLotsDesc"  type="textarea"  rows="1" autosize label="签语" label-width="3em" readonly />
      <van-field v-model="item.drawLotsNumber" label="数量" input-align="right" readonly >
        <span slot="right-icon">份</span>
      </van-field>
      <van-field v-model="item.drawLotsProb" label="获得概率" input-align="right" readonly >
        <span slot="right-icon">%</span>
      </van-field>
      <div class="state" v-if="from == 'manager'">
        <span>状态</span>
        <span>{{item.status == 0 ? '已上架': '已下架'}}</span>
      </div>
    </div>
    <div class="add-range-btn" @click="addDrawsots">添加签</div>
    <div class="reserve-title">背景音乐设置</div>
    <div class="com-card card-music">
      <van-field
        readonly
        clickable
        right-icon="arrow"
        input-align="right"
        v-model="drawLotsData.backgroundMusicName"
        label="背景音乐"
        placeholder="请选择"
        :rules="[{ required: true, message: '请选择背景音乐' }]"
        @click="isPicker = true"
      />
    </div>
  
    <template v-if="drawLotsData.drawLots.length">
      <div class="reserve-title">求签兑奖设置</div>
      <div class="com-card"  v-for="(item,index) in drawLotsData.drawLotsPrizes" :key="index + 1 * 100 ">
        <div class="left">
          <img class="left" :src="item.prizeImg" alt="" />
          <span v-if="from == 'manager'">{{item.status == 0 ? '已上架': '已下架'}}</span>
        </div>
        <div class="right">
          <div class="name">{{item.prizeName}}</div>
          <div class="number-box">
            <div class="number">库存： {{item.inventory}}</div>
            <div class="number" v-if="from == 'manager'">剩余库存： {{item.residueNumber}}</div>
          </div>
          <div>
            兑换条件：
            <span  v-for="(item,index) in item.conditions" :key="index">
              <template v-if="item.exchangeNeedNumber > 0">
                {{item.drawLotsTitle}}
              </template>
            </span>

          </div>
          <div class="button-box">
            <span class="edit" @click="editPrize(item,index)" v-if="from != 'manager'">编辑</span>
            <span class="edit" @click="editPrize(item,index)" v-else>
                {{item.status == 0 ? '下架并编辑' : '编辑并上架'}}
            </span>
            <span @click="delPrize(item,index)">删除</span>
          </div>
        </div>
      </div>
      <div class="add-range-btn" @click="addPrize">添加奖品</div>
    </template>
    
    <div class="reserve-title">求签机会设置</div>
    <drawlots-conf v-model="drawLotsData" ref="drawLotsRef"/>
    <add-drawlots-pop 
      :isAddDrawsotsPop.sync="isAddDrawsotsPop" 
      :defaultPhoneHeight="defaultPhoneHeight"
      :drawLots="drawLots"
      :allDrawLots="allDrawLots"
      @drawLotsSaveSuccess="drawLotsSaveSuccess"
      @changFoot="changFoot"
    />
    <add-prize-pop 
      :isAddPrizePop.sync="isAddPrizePop" 
      :defaultPhoneHeight="defaultPhoneHeight"
      :prize="prize"
      @prizeSaveSuccess="prizeSaveSuccess"
      @changFoot="changFoot"
    />
    <van-popup v-model="isPicker" position="bottom" get-container="body" >
      <van-picker
        value-key="name"
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
    </van-popup>
  </div>
</template>
<script>
import addDrawlotsPop from './add-drawlots-pop'
import lotsPrizeCard from './lots-prize-card'
import addPrizePop from './add-drawsots-prize-pop'
import drawlotsConf from './drawlots-conf'
export default {
  props: {
    value:  {
      type: Object,
      default() {
        return {}
      }
    },
  },
  components: {
    addDrawlotsPop,
    lotsPrizeCard,
    addPrizePop,
    drawlotsConf
  },
  computed: {
    drawLotsData: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('change',newVal)
      }
    },
    from() {
      return this.$route.query.from
    },
  },
  data() {
    return {
      defaultPhoneHeight: 0,
      isAddDrawsotsPop: false,
      isAddPrizePop: false,
      isEdit: false,
      currentLotsIndex: '',
      drawLots: {},
      allDrawLots: [],
      prize: {},
      isEditPrize: false,
      currentPrizeIndex: '',
      isPicker: false,
      columns: []
    }
  },
  methods: {
    addDrawsots() {
      this.isEdit = false
      this.drawLots = {
        activityId: this.drawLotsData.activityId || '',
        type: '',
        typeName: '',
        definitionTitle: '',
        drawLotsDesc: '',
        drawLotsNumber: '',
        drawLotsProb: '',
        img: '',
        imgList: [],
        status: 0,
        isNewAdd: true
      }
      this.isAddDrawsotsPop = true
      this.allDrawLots = this.getAllDrawsots()
    },
    async edit(item,index) {
      this.currentLotsIndex = index
      this.isEdit = true
      this.allDrawLots = this.getAllDrawsots()
      let sub = this.allDrawLots.indexOf(item.typeName)
      this.allDrawLots.splice(sub,1)
      if (this.from != 'manager') {
        this.drawLots = {...item,imgList: [{url: item.img}]}
      }else {
        const { activityId,id} = item
        const res = await this.$api.drawlots.getDrawLots(id)
        this.drawLots = res.data
        if (res.data.type == 'definition') {
          this.drawLots = { ...res.data, imgList: [{url: res.data.img}]}
        }
        await this.$api.drawlots.drawLotsEdit({activityId,drawLotsId:id})
        item.status = 1
        this.$emit('lotsHandler', item,index , true)
      }
      this.isAddDrawsotsPop = true
    },
    handleDel(index) {
      this.$dialog.confirm({
        title: '删除确定',
        message:`请问是否删除当前签<br/>删除后无法恢复`,
      }).then(_ =>{
        this.drawLotsData.drawLots.splice(index, 1)
        this.$toast('删除成功')
      })
    },
    drawLotsSaveSuccess(drawLots) {
      if (this.isEdit) {
        this.drawLotsData.drawLots[this.currentLotsIndex] = drawLots
        // 已经发布的活动 编辑、保存、新增直接改变父组件数据(只针对卡片式创建方式)
        if (this.from == 'manager') {
          this.$emit('lotsHandler', drawLots,this.currentLotsIndex, true)
        }
      }else {
        this.drawLotsData.drawLots.push(drawLots)
        if (this.from == 'manager') {
          this.$emit('lotsHandler', drawLots)
        }
      }
    },
    getAllDrawsots() {
      let allDrawLots = []
      this.drawLotsData.drawLots.forEach(item => {
        allDrawLots.push(item.typeName)
      });
      return allDrawLots
    },
    // 奖品相关操作
    addPrize() {
      this.prize = {
        activityId: this.drawLotsData.activityId || '',
        prizeImg: '',
        prizeImgList: [],
        prizeName: '',
        canExchangeTimes: '',
        prizeType: '',
        prizeTypeStr: '',
        frequency: '',
        isNewAdd: true,
        conditions: [],
        prizeImgType: '',
        prizeImgTypeStr: ''
      }
      this.isEditPrize = false
      let result = this.checkRepeat(this.drawLotsData.drawLots,'typeName')
      if (result) {
        this.$toast('有重复签，请先去重')
        return 
      }
      this.drawLotsData.drawLots.forEach(item => {
        this.prize.conditions.push({
          drawLotsTitle: item.type == 'definition' ? item.definitionTitle : item.typeName,
          exchangeNeedNumber: ''
        })
      });
      this.isAddPrizePop = true
    },
    async editPrize(item, index) {
      this.isEditPrize = true
      this.currentPrizeIndex = index
      if (this.from != 'manager') {
        this.prize = {...item,prizeImgList: [{url: item.prizeImg}] }
      } else{
        const {activityId, id} = item
        await this.$api.drawlots.prizeEdit({activityId,prizeId:id})
        item.status = 1
        const res = await this.$api.drawlots.getPrize(id)
        this.prize = {
          ...res.data,
          residueNumber: item.residueNumber,
          prizeImgList:[{url: res.data.prizeImg}],
        }
        this.$emit('prizeHandler', item, index, true)
      }
      this.isAddPrizePop = true
    },
    delPrize(item,index) {
      this.$dialog.confirm({
        title: '删除确定',
        message:`请问是否删除当前奖品<br/>删除后无法恢复`,
      }).then(async _ =>{
        if (this.from == 'manager') {
          let { id,activityId } = item
          await this.$api.drawlots.deletePrize({prizeId: id,activityId })
          this.$emit('prizeDel',index)
        }
        this.drawLotsData.drawLotsPrizes.splice(index, 1)
        this.$toast('删除成功')
       
      })
    },
    prizeSaveSuccess(prize) {
      if (this.isEditPrize) {
        this.drawLotsData.drawLotsPrizes[this.currentPrizeIndex] = prize
        if (this.from == 'manager') {
          this.$emit('prizeHandler', prize, this.currentPrizeIndex, true)
        }
      }else {
        this.drawLotsData.drawLotsPrizes.push(prize)
        if (this.from == 'manager') {
          this.$emit('prizeHandler', prize)
        }
      }
    },
    onConfirm(e) {
      const {name,url} = e
      this.drawLotsData.backgroundMusic = url
      this.drawLotsData.backgroundMusicName = name
      this.isPicker = false
    },
    onCancel() {
      this.isPicker = false
    },
    // 验证求签设置参数
    verifyDrawLots() {
      // 判断是否有重复签
      let result = this.checkRepeat(this.drawLotsData.drawLots,'typeName')
      if (result) {
        this.$toast('有重复签，请先去重')
        return false
      }
      if (!this.drawLotsData.drawLots.length) {
        this.$toast('请先添加签')
        return false
      } else {
        // 求签机会设置参数验证
        return this.$refs.drawLotsRef.checkValid()
      }
    },
    checkRepeat(arr, val) {
      let array = [];
      arr.forEach((item) => {
        if (item) {
          if (item.type == 'definition') {
            array.push(item.definitionTitle);
          }else {
            array.push(item[val]);
          }
         
        }
      });
      if (new Set(array).size != arr.length) {
        return true;
      }
      return false;
    },
    changFoot(isShow) {
      this.$emit('changFoot', isShow)
    },
    getMusicList() {
      this.$api.question.getBackgroundMusicList()
        .then(res => {
          this.columns = res.data
        })
    }
  },
  created() {
    this.defaultPhoneHeight = window.innerHeight
    this.getMusicList()
  }
}
</script>

<style lang="stylus" scoped>
.reserve {
  margin: 15px 0;
  margin-top: 10px;
  .reserve-title {
    padding: 10px 0 0 20px
    font-size: 14px;
    font-weight: bold;
    color: #303133;
  }
  .com-content {
    margin 10px 15px
    padding 4px
    background-color: #fff
    border-radius: 8px;
    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #606266;
      font-weight: 600;
      height: 30px;
      margin: 0 15px;
      .replace {
        color: #ff6b31;
      }
      .replace:last-child {
        margin-left: 10px;
      }
    }
    .state {
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
      margin: auto;
      width: 91%;
      padding: 10px 0;
      overflow: hidden;
      color: #323233;
      font-size: 14px;
      line-height: 24px;
      background-color: #fff;
    }
    .signup-type {
      span {
        margin-left: 10px;
      }
    }
    .commodity-box {
      display: flex;
      justify-content: space-between;
      margin: 15px;
      padding-bottom: 6px;
      border-bottom: 1px solid #ebedf0;
      .name {
        flex: 1;
        margin-right: 4px;
        display: flex;
        .name-state {
          font-size: 12px;
          color: #999;
          margin: 2px 10px 0 0;
        }
        .title {
          display: inline-block;
          // width: 100px;
           flex: 1;
        }
      }
      .icon-box {
        display: flex;
        align-items: center;
        color: #ff6b31;
        .add {
          margin-right: 10px;
        }
        .del {
          margin-right: 10px;
        }
      }
    }
    .add-goods-btn {
      margin 12px
      padding 6px 0
      text-align: center
      color $mainTextColor
      font-size 12px
      font-weight 600
      border 1px solid $mainTextColor
      border-radius 4px
    }
  }
  .add-range-btn {
    margin 10px 15px
    padding 6px 0
    text-align: center
    color $mainTextColor
    font-size 14px
    font-weight 600
    border 1px solid $mainTextColor
    border-radius 8px
  }
  .com-card {
    display: flex;
    margin 10px 15px
    padding 6px
    background-color: #fff
    border-radius: 8px;
    .left {
      position: relative;
      width: 100px;
      height: 100px;
      span {
        position: absolute;
        left: 0;
        top: 0;
        font-size: 12px;
        color: $mainTextColor
      }
    }
    .right {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-left: 10px;
      flex: 1;
      .name {}
      .number-box {
        display: flex;
        justify-content: space-between;
      }
      .button-box {
        display: flex;
        justify-content: flex-end;
        color: #ff6b31;
        .edit {
          margin-right: 10px;
        }
      }
    }
  }
  .comContentMargin {
    margin: 10px 15px;
  }
  .card-music {
    padding: 0;
  }
}
</style>